import { RequestAction, createRequestTypes } from "store/entities/actions";
import { IMailbox } from "store/entities/mailboxes/interfaces";
import { ActionsUnion, createAction } from "store/helper";

import {
  IAddCannedResponsePayload,
  IAddTagPayload,
  ICreateMailboxPayload,
  IDeleteCannedResponsePayload,
  IDeleteCustomViewPayload,
  IDeleteMailboxPayload,
  IDeleteTagPayload,
  IDomainConfigurationCopiedPayload,
  IGoToCustomViewPayload,
  ISetFocusedColumnPayload,
  ISetTeamPayload,
  IUpdateCannedResponsePayload,
  IUpdateCustomViewPayload,
  IUpdateDefaultMailboxPayload,
  IUpdateMailboxPayload,
  IUpdateNotificationsPayload,
  IUpdateTagPayload,
} from "./interfaces";

export const SettingsViewActionsNames = {
  SET_FOCUSED_COLUMN: "VIEWS/ACTIONS/SET_FOCUSED_COLUMN",
  UPDATE_COMPANY_NAME: "VIEW/ACTIONS/UPDATE_COMPANY_NAME",
  SET_TEAM_ID: "VIEWS/ACTIONS/SET_TEAM_ID",
  MAILBOX_COPIED: "VIEWS/ACTIONS/MAILBOX_COPIED",
  CREATE_EMAIL_DOMAIN: "VIEWS/ACTIONS/CREATE_EMAIL_DOMAIN",
  DELETE_EMAIL_DOMAIN: "VIEWS/ACTIONS/DELETE_EMAIL_DOMAIN",
  DOMAIN_CONFIGURATION_COPIED: "VIEWS/ACTIONS/DOMAIN_CONFIGURATION_COPIED",
  FORWARDING_ADDRESS_COPIED: "VIEWS/ACTIONS/FORWARDING_ADDRESS_COPIED",
  UPDATE_DEFAULT_MAILBOX_SETTINGS: "VIEWS/ACTIONS/UPDATE_DEFAULT_MAILBOX_SETTINGS",

  ADD_TAG: "VIEWS/ACTIONS/ADD_TAG",
  UPDATE_TAG: "VIEWS/ACTIONS/UPDATE_TAG",
  DELETE_TAG: "VIEWS/ACTIONS/DELETE_TAG",

  ADD_CANNED_RESPONSE: "VIEWS/ACTIONS/ADD_CANNED_RESPONSE",
  UPDATE_CANNED_RESPONSE: "VIEWS/ACTIONS/UPDATE_CANNED_RESPONSE",
  DELETE_CANNED_RESPONSE: "VIEWS/ACTIONS/DELETE_CANNED_RESPONSE",
  DELETE_CANNED_RESPONSE_ATTACHMENT: "VIEWS/ACTIONS/DELETE_CANNED_RESPONSE_ATTACHMENT",

  GO_TO_DOMAIN_SETUP: "VIEWS/ACTIONS/GO_TO_DOMAIN_SETUP",

  GO_TO_CUSTOM_VIEW: "VIEWS/SETTINGS/GO_TO_CUSTOM_VIEW",
  UPDATE_CUSTOM_VIEW: "VIEWS/SETTINGS/UPDATE_CUSTOM_VIEW",
  DELETE_CUSTOM_VIEW: "VIEWS/SETTINGS/DELETE_CUSTOM_VIEW",

  UPDATE_NOTIFICATIONS: createRequestTypes("VIEWS/ACTIONS/UPDATE_NOTIFICATIONS"),

  CREATE_MAILBOX: "VIEWS/SETTINGS/CREATE_MAILBOX",
  UPDATE_MAILBOX: "VIEWS/SETTINGS/UPDATE_MAILBOX",
  DELETE_MAILBOX: "VIEWS/SETTINGS/DELETE_MAILBOX",
  DELETE_MAILBOXES: "VIEWS/SETTINGS/DELETE_MAILBOXES",

  FETCH_NEXT_FORWARDING_ADDRESS: createRequestTypes("VIEWS/SETTINGS/FETCH_NEXT_FORWARDING_ADDRESS"),
};

export const SettingsViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setFocusedColumn: (payload: ISetFocusedColumnPayload) =>
    createAction(SettingsViewActionsNames.SET_FOCUSED_COLUMN, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateCompanyName: (companyName: string) =>
    createAction(SettingsViewActionsNames.UPDATE_COMPANY_NAME, { companyName }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setTeamId: (payload: ISetTeamPayload) => createAction(SettingsViewActionsNames.SET_TEAM_ID, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mailboxCopied: () => createAction(SettingsViewActionsNames.MAILBOX_COPIED),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  domainConfigurationCopied: (payload: IDomainConfigurationCopiedPayload) =>
    createAction(SettingsViewActionsNames.DOMAIN_CONFIGURATION_COPIED, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  forwardingAddressCopied: () => createAction(SettingsViewActionsNames.FORWARDING_ADDRESS_COPIED),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createEmailDomain: (name: string) => createAction(SettingsViewActionsNames.CREATE_EMAIL_DOMAIN, { name }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteEmailDomain: (id: string) => createAction(SettingsViewActionsNames.DELETE_EMAIL_DOMAIN, { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultMailboxSettings: (payload: IUpdateDefaultMailboxPayload) =>
    createAction(SettingsViewActionsNames.UPDATE_DEFAULT_MAILBOX_SETTINGS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addTag: (payload: IAddTagPayload) => createAction(SettingsViewActionsNames.ADD_TAG, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTag: (payload: IUpdateTagPayload) => createAction(SettingsViewActionsNames.UPDATE_TAG, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTag: (payload: IDeleteTagPayload) => createAction(SettingsViewActionsNames.DELETE_TAG, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addCannedResponse: (payload: IAddCannedResponsePayload) =>
    createAction(SettingsViewActionsNames.ADD_CANNED_RESPONSE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateCannedResponse: (payload: IUpdateCannedResponsePayload) =>
    createAction(SettingsViewActionsNames.UPDATE_CANNED_RESPONSE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCannedResponse: (payload: IDeleteCannedResponsePayload) =>
    createAction(SettingsViewActionsNames.DELETE_CANNED_RESPONSE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCannedResponseAttachment: (id: string, attachmentIndex: number) =>
    createAction(SettingsViewActionsNames.DELETE_CANNED_RESPONSE_ATTACHMENT, { id, attachmentIndex }),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateNotifications: (payload: IUpdateNotificationsPayload) =>
    createAction(SettingsViewActionsNames.UPDATE_NOTIFICATIONS[RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  goToCustomView: (payload: IGoToCustomViewPayload) =>
    createAction(SettingsViewActionsNames.GO_TO_CUSTOM_VIEW, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateCustomView: (payload: IUpdateCustomViewPayload) =>
    createAction(SettingsViewActionsNames.UPDATE_CUSTOM_VIEW, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCustomView: (payload: IDeleteCustomViewPayload) =>
    createAction(SettingsViewActionsNames.DELETE_CUSTOM_VIEW, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createMailbox: (payload: ICreateMailboxPayload) => createAction(SettingsViewActionsNames.CREATE_MAILBOX, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateMailbox: (payload: IUpdateMailboxPayload) => createAction(SettingsViewActionsNames.UPDATE_MAILBOX, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteMailbox: (payload: IDeleteMailboxPayload) => createAction(SettingsViewActionsNames.DELETE_MAILBOX, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteMailboxes: (payload: IMailbox["id"][]) => createAction(SettingsViewActionsNames.DELETE_MAILBOXES, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchNextForwardingAddress: () =>
    createAction(SettingsViewActionsNames.FETCH_NEXT_FORWARDING_ADDRESS[RequestAction.REQUEST], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchNextForwardingAddressSuccess: ({ name }: { name: string }) =>
    createAction(SettingsViewActionsNames.FETCH_NEXT_FORWARDING_ADDRESS[RequestAction.SUCCESS], { name }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchNextForwardingAddressFailure: () =>
    createAction(SettingsViewActionsNames.FETCH_NEXT_FORWARDING_ADDRESS[RequestAction.FAILURE], {}),
};

export type SettingsViewAction = ActionsUnion<typeof SettingsViewActions>;
